/**
 * Toggle mostra/nascondi password su <button class="js-password-eye"> (vedi snippets/input-password.liquid).
 * Usa un button HTML nativo perché su iOS il tap spesso non diventa "click" sui custom element mc-password-eye.
 */
(function () {
	function inputFor(btn) {
		var id = btn.getAttribute('data-password-input');
		return id ? document.getElementById(id) : null;
	}

	function sync(btn) {
		var el = inputFor(btn);
		if (!el) return;
		var visible = el.type === 'text';
		btn.classList.toggle('active', visible);
		btn.setAttribute('aria-pressed', visible ? 'true' : 'false');
	}

	function toggle(btn) {
		var el = inputFor(btn);
		if (!el || (el.type !== 'password' && el.type !== 'text')) return;
		el.type = el.type === 'password' ? 'text' : 'password';
		sync(btn);
	}

	function scan(root) {
		var scope = root && root.querySelectorAll ? root : document;
		scope.querySelectorAll('.js-password-eye').forEach(sync);
	}

	document.addEventListener(
		'click',
		function (e) {
			var btn = e.target.closest && e.target.closest('.js-password-eye');
			if (!btn) return;
			e.preventDefault();
			toggle(btn);
		},
		true
	);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			scan(document);
		});
	} else {
		scan(document);
	}

	try {
		new MutationObserver(function (muts) {
			muts.forEach(function (m) {
				m.addedNodes.forEach(function (node) {
					if (node.nodeType !== 1) return;
					if (node.matches && node.matches('.js-password-eye')) sync(node);
					if (node.querySelectorAll) scan(node);
				});
			});
		}).observe(document.documentElement, { childList: true, subtree: true });
	} catch (err) {
		/* ignore */
	}
})();
